import type { AgPayload, AirPayload, AlertEntry, RadarPayload, WeatherPayload } from '../types';

async function getJson<T>(path: string): Promise<T> {
  const r = await fetch(path);
  if (!r.ok) throw new Error(`${path} failed (${r.status})`);
  return (await r.json()) as T;
}

export const fetchWeather = (farmId: string) =>
  getJson<WeatherPayload>('/api/weather?farm=' + encodeURIComponent(farmId));
export const fetchAlerts = () => getJson<{ alerts: AlertEntry[] }>('/api/alerts');
export const fetchRadar = () => getJson<RadarPayload>('/api/radar');
export const fetchAg = (farmId: string) => getJson<AgPayload>('/api/ag?farm=' + encodeURIComponent(farmId));
export const fetchAir = () => getJson<AirPayload>('/api/air');

export interface SatelliteMeta {
  geoColor: { timestamps: string[]; tileUrlTemplate: string };
  infrared: { timestamps: string[]; tileUrlTemplate: string };
  generatedAt: string;
}
export const fetchSatellite = () => getJson<SatelliteMeta>('/api/satellite');

export interface WindGrid {
  latMin: number;
  latMax: number;
  lonMin: number;
  lonMax: number;
  nLat: number;
  nLon: number;
  u: number[];
  v: number[];
  time: string;
}
export const fetchWind = () => getJson<WindGrid>('/api/wind');
